import { CircularProgress } from "@mui/material";
import { context } from '..';
import { observer } from "mobx-react-lite";


export default observer(function RedirectPage () {

    return (
        <div className="main-inner">
            <div style={{maxWidth: "600px"}}>
                {context.redirectCountdown !== null ? (
                    <div style={{display: "flex", gap: "20px", alignItems: "center"}}>
                        <CircularProgress style={{width: "24px", height: "24px"}} />

                        <h1 style={{fontSize: "30px", fontWeight: "800"}}>Redirecting in {context.redirectCountdown}</h1>
                    </div>
                ) : null}

                <p>You have been logged out, please re-open the Questionnaire if you need to coninue.</p>
            </div>
        </div>
    )
})